'use client';

import { useLocale } from "next-intl";
import { useRouter, usePathname } from "@/i18n/navigation";
import { routing } from "@/i18n/routing";
import { useTransition } from "react";
import { Globe } from "lucide-react";
import { Dropdown, DropdownOption } from "@/components/ui/dropdown";

export default function LocaleSwitcher() {
  const router = useRouter();
  const pathname = usePathname();
  const [isPending, startTransition] = useTransition();
  const currentLocale = useLocale();
  const localePrefixPattern = new RegExp(`^/(?:${routing.locales.join("|")})(?=/|$)`);

  const localeOptions: DropdownOption[] = [
    { value: 'en', label: 'English', icon: Globe },
    { value: 'es', label: 'Español', icon: Globe },
  ];

  const handleLocaleChange = (value: string) => {
    startTransition(() => {
      const normalizedPathname = pathname || "/";
      const pathWithoutLocale = normalizedPathname.replace(localePrefixPattern, "");
      const finalPath = pathWithoutLocale
        ? pathWithoutLocale.startsWith("/")
          ? pathWithoutLocale
          : `/${pathWithoutLocale}`
        : "/";
      router.push(finalPath, { locale: value });
    });
  };

  return (
    <div className="locale-switcher">
      <Dropdown
        options={localeOptions}
        value={currentLocale}
        onChange={handleLocaleChange}
        disabled={isPending}
        minWidth="150px"
        direction="up"
        theme="default"
        buttonClassName="flex h-11 items-center gap-2 rounded-full border border-white/40 bg-white/80 px-4 text-sm font-semibold shadow-md backdrop-blur transition hover:-translate-y-0.5 hover:shadow-lg dark:border-white/15 dark:bg-surface-dark/80 dark:text-white"
        dropdownClassName="rounded-2xl border border-white/30 bg-white/95 shadow-2xl backdrop-blur dark:bg-surface-dark/95 dark:border-white/15"
      />
    </div>
  );
}
